<template>
    <div class="animated fadeIn efficiency">
        <filters :scope="filtersScope">
        </filters>

        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        @isPopup="isPopup"
                        ref="statisticTable"
                        :title="`${$t('pages.order')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map } from 'lodash'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import StatisticTable from '../../../components/StatisticTable.vue'

  export default {
    name: 'Order',
    components: {
      Filters,
      StatisticTable
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          operatorFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.operator'), field: 'operator'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'},
          {label: this.$root.$t('statistic.ProcessAccept'), field: 'ProcessAccept'},
          {label: this.$root.$t('statistic.ProcessCancel'), field: 'ProcessCancel'},
          {label: this.$root.$t('statistic.ProcessSpam'), field: 'ProcessSpam'},
          {label: this.$root.$t('statistic.AcceptCancel'), field: 'AcceptCancel'},
          {label: this.$root.$t('statistic.CancelAccept'), field: 'CancelAccept'},
          {label: this.$root.$t('statistic.SpamAccept'), field: 'SpamAccept'}
        ],
        rows: [],
        footColumns: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      isPopup (cell) {
        let el = document.createElement('textarea')
        el.value = cell.value.trim()
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        alert('Скопирован оператор ' + el.value)
      },
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        API.getOperatorOrder().then(response => {
          this.operators = Storage.operators.slice(0)
          let statistic = {}
          let sumTotal = 0
          let countTotal = 0
          let sumProcessAccept = 0
          let sumProcessCancel = 0
          let sumProcessSpam = 0
          let sumAcceptCancel = 0
          let sumCancelAccept = 0
          let sumSpamAccept = 0
          map(response.body, (operatorData, id) => {
            statistic[id] = operatorData[0]
            statistic[id].operator_id = id
            map(operatorData, (val, key) => {
              if (key !== 0) {
                statistic[id].process_accept += parseInt(val.process_accept)
                statistic[id].total += parseInt(val.total)
                statistic[id].cancel_accept += parseInt(val.cancel_accept)
                statistic[id].accept_cancel += parseInt(val.accept_cancel)
                statistic[id].process_cancel += parseInt(val.process_cancel)
                statistic[id].process_spam += parseInt(val.process_spam)
                statistic[id].spam_accept += parseInt(val.spam_accept)
              }
            })
          })
          map(statistic, (d) => {
            this.rows.push({
              operator: {value: `${Helper.getOperatorLogin(this.operators, d.operator_id)} ${Storage.developMode ? `(${d.operator_id})` : ''}`, popup: true},
              total: {
                value: parseInt(d.total),
                bg: true
              },
              approvedFromValid: {
                value: Helper.approvedFromValid(d.process_accept, d.total, d.spam_accept)
              },
              ProcessAccept: {
                value: parseInt(d.process_accept),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.process_accept)
              },
              ProcessCancel: {
                value: parseInt(d.process_cancel),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.process_cancel)
              },
              ProcessSpam: {
                value: parseInt(d.process_spam),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.process_cancel)
              },
              AcceptCancel: {
                value: parseInt(d.cancel_accept),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.cancel_accept)
              },
              CancelAccept: {
                value: parseInt(d.accept_cancel),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.accept_cancel)
              },
              SpamAccept: {
                value: parseInt(d.spam_accept),
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.spam_accept)
              }
            })
            if (d.total > 0) {
              sumTotal += parseInt(d.total)
              countTotal++
            }
            if (d.process_accept > 0) {
              sumProcessAccept += parseInt(d.process_accept)
            }
            if (d.process_cancel > 0) {
              sumProcessCancel += parseInt(d.process_cancel)
            }
            if (d.process_spam > 0) {
              sumProcessSpam += parseInt(d.process_spam)
            }
            if (d.cancel_accept > 0) {
              sumAcceptCancel += parseInt(d.cancel_accept)
            }
            if (d.accept_cancel > 0) {
              sumCancelAccept += parseInt(d.accept_cancel)
            }
            if (d.spam_accept > 0) {
              sumSpamAccept += parseInt(d.spam_accept)
            }
          })
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            total: {
              value: `${sumTotal} (${Helper.average(sumTotal, countTotal)})`
            },
            approvedFromValid: {
              value: Helper.approvedFromValid(sumProcessAccept, sumTotal, sumProcessSpam)
            },
            ProcessAccept: {
              value: `${sumProcessAccept}`
            },
            ProcessCancel: {
              value: `${sumProcessCancel}`
            },
            ProcessSpam: {
              value: `${sumProcessSpam}`
            },
            AcceptCancel: {
              value: `${sumAcceptCancel}`
            },
            CancelAccept: {
              value: `${sumCancelAccept}`
            },
            SpamAccept: {
              value: `${sumSpamAccept}`
            }
          }
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Order.vue?e4e9862c